import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import Select from "react-select"
import { useDispatch, useSelector } from 'react-redux'
import { getActivitiesPublicByFilter, getSitesPublicForFilter, getSportsPublicForFilter } from '../../../actions/filtersActions'

export default function SearchActivities({ancho, filters = null}){
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const {sitesfilter, sportsfilter} = useSelector(state=>state.filters)

    const [filterOptions, setFilterOptions] = useState({activity: '', province: null, sport: null})
    const [provincesOptions, setProvincesOptions] = useState([])
    const [sportsOptions, setSportsOptions] = useState([])

    useEffect(() =>{
        dispatch(getSitesPublicForFilter())
        dispatch(getSportsPublicForFilter())
    }, [dispatch])

    useEffect(() => {
        if (filters) {
            setFilterOptions(filters)
            dispatch(getActivitiesPublicByFilter(filters))
        }
    }, [filters])

    useEffect(() => {
        if (sitesfilter) {
            const uniqueProvinces = [...new Set(sitesfilter.map(site => site?.province))]
            let arrayOptionsProvinces = uniqueProvinces.map(province => ({label: province, value: province}))
            arrayOptionsProvinces.unshift({label: t('marketplace.allprovinces'), value: null});
            setProvincesOptions(arrayOptionsProvinces)
        }
    }, [sitesfilter, t])

    useEffect(() => {
        if (sportsfilter) {
            let arrayOptionsSports = sportsfilter.map(sport => ({label: t('sports.'+sport), value: sport}))
            arrayOptionsSports.unshift({label: t('marketplace.allsports'), value: null});
            setSportsOptions(arrayOptionsSports)
        }
    }, [sportsfilter, t])

    const handleInputChange = ({target})=>{
        setFilterOptions({
            ...filterOptions,
            'activity': target.value
        })
    }

    const handleSelectChange = (target, selecttype) => {
        setFilterOptions({
            ...filterOptions,
            [selecttype]: target.value
        })
    }

    const searchActivities = () => {
        dispatch(getActivitiesPublicByFilter(filterOptions))
    }

    const clearSearch = () => {
        setFilterOptions({activity: '', province: null, sport: null})
        dispatch(getActivitiesPublicByFilter({activity: '', province: null, sport: null}))
    }

    return (
        <div className='search-bar-inline' style={{ width: ancho }}>
            <Row className='align-items-center g-2'>
                <Col>
                    <Form.Control
                        type="text"
                        name="activity"
                        onChange={handleInputChange}
                        value={filterOptions?.activity}
                        placeholder={t('marketplace.activitysearch')}
                        className='search-bar-input'
                    />
                </Col>
                <Col>
                    <Select
                        className="search-bar-select"
                        classNamePrefix="search-bar-select"
                        name="province"
                        options={provincesOptions}
                        value={provincesOptions?.find(option => option?.value === filterOptions?.province)}
                        placeholder={t('marketplace.province')}
                        onChange={(e) => handleSelectChange(e, 'province')}
                    />
                </Col>
                <Col>
                    <Select
                        className="search-bar-select"
                        classNamePrefix="search-bar-select"
                        name="sport"
                        options={sportsOptions}
                        value={sportsOptions?.find(option => option?.value === filterOptions?.sport)}
                        placeholder={t('marketplace.sport')}
                        onChange={(e) => handleSelectChange(e, 'sport')}
                    />
                </Col>
                <Col xs='auto'>
                    <div className='search-bar-actions'>
                        <Button variant='primary' type="submit" className="btn-search-bar" onClick={() => searchActivities()}>
                            {t('marketplace.search')}
                        </Button>
                        {filterOptions.activity || filterOptions.province || filterOptions.sport ?
                            <span className="search-bar-clear cursor" onClick={() => clearSearch()}>
                                {t('marketplace.clearsearch')}
                            </span>
                        : null}
                    </div>
                </Col>
            </Row>
        </div>
    )
}
